import axios from "axios";

export default axios.create({
  // baseURL: "/muhly",
  baseUrl: "/muhly",
});
